import { sessionStorageStore } from './storage';

export const delegate: string | undefined = sessionStorageStore.get().delegate;
